// DashboardHeader.jsx
import React, { useState } from 'react';
import { Menu, Bell, Search, ChevronDown, Settings, LogOut, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { AuthService } from '../../../services/AuthService';
import './DashboardHeader.css';

const DashboardHeader = ({ toggleSidebar, user }) => {
    const [showUserMenu, setShowUserMenu] = useState(false);
    const [showNotifications, setShowNotifications] = useState(false);
    const navigate = useNavigate();

    // Notifications d'exemple
    const notifications = [
        {
            id: 1,
            title: 'Nouvelle annonce',
            message: 'Une nouvelle annonce a été soumise',
            time: '5 min',
            read: false
        },
        {
            id: 2,
            title: 'Paiement validé',
            message: 'Le paiement de Techno Solutions CI a été validé',
            time: '1h',
            read: false
        },
        {
            id: 3,
            title: 'Annonce publiée',
            message: 'L\'annonce de Bouaké Transport a été publiée',
            time: '2h',
            read: true
        }
    ];

    const unreadCount = notifications.filter(n => !n.read).length;

    const handleLogout = () => {
        AuthService.logout(navigate);
    };

    const handleProfileClick = () => {
        navigate('/dashboard/parametres');
        setShowUserMenu(false);
    };

    const handleSettingsClick = () => {
        navigate('/dashboard/parametres');
        setShowUserMenu(false);
    };

    const markNotificationAsRead = (notificationId) => {
        // Logique pour marquer comme lu
        console.log('Marquer notification comme lue:', notificationId);
    };

    return (
        <header className="dashboard-header">
            <div className="header-left">
                <button
                    className="mobile-menu-button"
                    onClick={toggleSidebar}
                    title="Menu"
                >
                    <Menu size={24} />
                </button>

                <div className="header-title">
                    <h1>Fraternité Matin - Gestion des annonces légales</h1>
                </div>
            </div>



            {/* Overlay pour fermer les dropdowns */}
            {(showUserMenu || showNotifications) && (
                <div
                    className="dropdown-overlay"
                    onClick={() => {
                        setShowUserMenu(false);
                        setShowNotifications(false);
                    }}
                />
            )}
        </header>
    );
};

export default DashboardHeader;